import React from "react";
import miniUGCimage from "assets/img/UltraGreen_logo_only_mini_web.png";
import { findCertType, certPreposition, formatCertDate } from "utils/ugcCertTypes";

/**
 * The certification line for one brand row.
 *
 * The single rendering of this string in the app. An unknown code, a brand
 * with no code and a failed lookup all render nothing, which is what the three
 * open-coded copies did before.
 *
 * The mark is shown only for a live certification: a terminated one is stated
 * in words, without the logo.
 */
const CertString = ({ brand, types }) => {
  const certType = findCertType(brand.ultraGreenCert, types);
  if (!certType) return null;

  const when = formatCertDate(brand.ultraGreenCertAuditDate);
  const active = certType.status === "ACTIVE";

  return (
    <div>
      {active && (
        <React.Fragment>
          <img src={miniUGCimage} width="80" alt="UltraGreen logo" />
          <br />
        </React.Fragment>
      )}
      {certType.label}
      {when && (
        <React.Fragment>
          <br />
          {certPreposition(certType.status)} {when}.
        </React.Fragment>
      )}
    </div>
  );
};

export default CertString;
